import React from 'react';
import PropTypes from 'prop-types';
import LoadingWidget from '../../LoadingWidget/LoadingWidget';
import { MenuItem, Select } from '@material-ui/core';
import './PageBaseView.css';

const PageBaseView = (props) => {
  return (
    <div>
      <span className="page-base-branch-select-container">
        <Select
          value={props.selectedBranchId}
          onChange={props.onChangeBranch}
          disabled={props.disableBranchSelect}
        >
          {props.branches.map((branch, index) => (
            <MenuItem key={index} value={branch.branchId}>
              {branch.default
                ? branch.branchDesc
                : `${branch.branchDesc} - ${branch.branchName}`}
            </MenuItem>
          ))}
        </Select>
        <span>
          {props.navigation.map((item, index) => (
            <span key={`crumb_${index}`}> / {item}</span>
          ))}
        </span>
      </span>
      <div className="page-base">
        {props.loading ? <LoadingWidget /> : null}
        <div className={props.loading ? 'hide' : 'show'}>{props.children}</div>
      </div>
    </div>
  );
};

PageBaseView.propTypes = {
  navigation: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.node])
  ).isRequired,
  loading: PropTypes.bool,
  selectedBranchId: PropTypes.number.isRequired,
  branches: PropTypes.array.isRequired,
  onChangeBranch: PropTypes.func.isRequired,
  disableBranchSelect: PropTypes.bool,
  includeInactiveBranches: PropTypes.bool
};

export default PageBaseView;
